import { useMedia } from 'react-use';

export default function useIsMobile(): boolean {
  const matches = useMedia('(max-width:600px)');

  return matches;
}
